import log from './logger'

const mapsUtils = window.google.maps;

export function nearestMarkers(home, markers) {
  let result = []

  markers.forEach(marker => {

    let markerLat = Number(marker.LAT);
    let markerLng = Number(marker.LNG);
    let markerCountryCode = marker.CountryCode;

    log('point', home, markerLat, markerLng, markerCountryCode);

    let distance = mapsUtils.geometry.spherical.computeDistanceBetween(
      new mapsUtils.LatLng(home.lat, home.lng),
      new mapsUtils.LatLng(markerLat, markerLng)
    );

    result.push({
      ...marker,
      distance,
    })
  })

  result.sort((a, b) => a.distance - b.distance)

  return result
}
